import type { Category } from "@/types/portal";
import { categories } from "@/mocks/site";

export function findCat(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}

export function catName(slug: string): string {
  return findCat(slug)?.name ?? "瓜闻";
}

// tint -> literal class map (kept static so Tailwind can scan them)
const tintBadge: Record<string, string> = {
  red: "bg-primary-50/90 text-primary-700 ring-primary-200/80",
  amber: "bg-accent-50 text-accent-800 ring-accent-200/90",
  stone: "bg-secondary-100/90 text-secondary-800 ring-secondary-200/80",
};
const tintDot: Record<string, string> = {
  red: "bg-primary-500",
  amber: "bg-accent-500",
  stone: "bg-secondary-500",
};

export function CategoryBadge({
  slug,
  label,
  className = "",
}: {
  slug?: string;
  label?: string;
  className?: string;
}) {
  const cat = slug ? findCat(slug) : undefined;
  const text = label ?? cat?.name ?? "瓜闻";
  const tint = cat?.tint ?? "stone";
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ring-1 ring-inset ${tintBadge[tint]} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${tintDot[tint]}`} />
      {text}
    </span>
  );
}

export function SectionHead({
  eyebrow,
  title,
  desc,
  action,
}: {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="mb-3 flex items-center gap-3">
          <span className="h-2.5 w-2.5 rounded-sm bg-primary-500" />
          <span className="font-en text-xs uppercase tracking-[0.28em] text-primary-600">
            {eyebrow}
          </span>
        </div>
        <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-[2rem]">
          {title}
        </h2>
        {desc ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}

export function goSection(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}